import { render, staticRenderFns } from "./FluxoCaixaContaExtratoList.vue?vue&type=template&id=0618fd60"
import script from "./FluxoCaixaContaExtratoList.vue?vue&type=script&lang=js"
export * from "./FluxoCaixaContaExtratoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports